import { combineReducers } from 'redux';

import activeQuestions from './activeQuestions';
import completedQuestions from './completedQuestions';

const reducer = combineReducers({
  activeQuestions,
  completedQuestions,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/scenes/Home/services/redux/index.js